/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';

export interface DeleteDevice$Params {
  deviceId: number;
}

export function deleteDevice(http: HttpClient, rootUrl: string, params: DeleteDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
  const rb = new RequestBuilder(rootUrl, deleteDevice.PATH, 'delete');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisteredDevice>;
    })
  );
}

deleteDevice.PATH = '/api/regdevice/{deviceId}';
